import { call, put, takeLatest } from "redux-saga/effects";
import {
  addSurveyDiaryAction,
  addSurveyEventAction,
  deleteSurveyEventAction,
  getLeadToSurveyAction,
  getSingleSurveyAction,
  getSingleSurveyEventAction,
  getSurveyDiaryAction,
  getSurveyDiaryWithEventAction,
  getSurvoyerListAction,
  setAddSurveyDiaryResponse,
  setAddSurveyEventAction,
  setDeleteSurveyEventAction,
  setLeadToSurveyAction,
  setSingleSurveyAction,
  setSingleSurveyEventAction,
  setSurveyDiaryAction,
  setSurveyDiaryWithEventAction,
  setSurvoyerListAction,
  setUpdateSurveyDiaryResponse,
  setUpdateSurveyEventAction,
  updateNewSurveyAction,
  updateSurveyDiaryAction,
  updateSurveyEventAction,
} from "../reducers/surveyDiarySlice";
import { setLoaderAction, setNotificationAction } from "../reducers/mmymSlice";
import { callAPI, handleError, handleSuccess } from "../api/api";

/**
 * This function for call the user profile
 *
 * @param {*} payload
 */

function* getSurveyDiaryWithEventSaga(payload: { payload: any }): any {
  yield put(setLoaderAction(true));
  try {
    const { startDate, endDate, ...newPayload } = payload?.payload;
    const res = yield call<any>(callAPI, {}, "get", `surveyors-task?startDate=${startDate}&endDate=${endDate}`);
    
    if (res?.data) {
      yield put(setSurveyDiaryWithEventAction(res?.data));
    }
  } catch (error) {
    
  }
  yield put(setLoaderAction(false));
}

function* getSurveyDiarySaga(): any {
  yield put(setLoaderAction(true));
  
  try {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      const userProfile = JSON.parse(storedUser);
      const userRole = userProfile?.user?.roles;

      let endpoint = "leads/surveys";
      if (
        userRole.includes("TENANT") ||
        userRole.includes("Admin") ||
        userRole.includes("Owner")
      ) {
        endpoint = "leads/surveys?all=true";
      }

      const res = yield call<any>(callAPI, {}, "get", endpoint);

      if (res?.data) {
        yield put(setSurveyDiaryAction(res?.data));
      }
    }
  } catch (error) {
    console.log("Catch Error-", error);
  }
  yield put(setLoaderAction(false));
}

function* getSurvoyerListSaga(): any {
  yield put(setLoaderAction(true));
  
  try {
    const res = yield call<any>(callAPI, {}, "get", `leads/surveyors`);
    
    if (res?.data) {
      yield put(setSurvoyerListAction(res?.data));
    }
  } catch (error) {
    console.log("Catch Error-", error);
  }
  yield put(setLoaderAction(false));
}

function* getLeadToSurveySaga(): any {
  yield put(setLoaderAction(true));
 
  try {
    const res = yield call<any>(callAPI, {}, "get", `leads/list-to-survey`);
    
    if (res?.data) {
      yield put(setLeadToSurveyAction(res?.data));
    }
  } catch (error) {
    console.log("Catch Error-", error);
  }
  yield put(setLoaderAction(false));
}

function* addSurveyDiarySaga(payload: { payload: any }): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const { leadId, endDate, ...newPayload } = payload?.payload;
    const apiResponse = yield call<any>(
      callAPI,
      { payload: newPayload },
      "post",
      `leads/${leadId}/assign-surveyor`,
    );
    
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setAddSurveyDiaryResponse(true));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setAddSurveyDiaryResponse(false));
  }
  yield put(setLoaderAction(false));
}

function* updateSurveyDiarySaga(action: { payload: any }): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
   
    const { id, ...payload } = action?.payload;
   
    const apiResponse = yield call<any>(
      callAPI,
      { payload: payload },
      "put",
      `surveys/${id}`,
    );
    
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setUpdateSurveyDiaryResponse(true));
    }
  } catch (error: any) {
    
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setUpdateSurveyDiaryResponse(false));
  }
  yield put(setLoaderAction(false));
}

function* updateNewSurveySaga(action: { payload: any }): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
 
    const { id, ...payload } = action?.payload;
   
    const apiResponse = yield call<any>(
      callAPI,
      { payload: payload },
      "post",
      `surveys/${id}/amend-survey`,
    );
   
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setUpdateSurveyDiaryResponse(true));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setUpdateSurveyDiaryResponse(false));
  }
  yield put(setLoaderAction(false));
}

function* getSingleSurveySaga(action: any): any {
  yield put(setLoaderAction(true));
  try {
    
    const id = action.payload; // Directly access the payload
    const singleRes = yield call<any>(
      callAPI,
      {},
      "get",
      `leads/surveys/${id}`,
    );
    
    if (singleRes?.data) {
      yield put(setSingleSurveyAction(singleRes?.data));
    }
  } catch (error) {
    console.log("Catch Error-", error);
  }
  yield put(setLoaderAction(false));
}

function* addSurveyEventSaga(payload: { payload: any }): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    
    const { leadId, assignTo, ...newPayload } = payload?.payload;
    const apiResponse = yield call<any>(
      callAPI,
      { payload: newPayload },
      "post",
      `client/personal-events`,
    );
    
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setAddSurveyEventAction(true));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setAddSurveyEventAction(false));
  }
  yield put(setLoaderAction(false));
}

function* getSingleSurveyEventSaga(action: any): any {
  yield put(setLoaderAction(true));
  try {
   
    const id = action.payload; // Directly access the payload
    const singleRes = yield call<any>(
      callAPI,
      {},
      "get",
      `client/personal-events/${id}`,
    );
   
    if (singleRes?.data) {
      yield put(setSingleSurveyEventAction(singleRes?.data));
    }
  } catch (error) {
    console.log("Catch Error-", error);
  }
  yield put(setLoaderAction(false));
}

function* updateSurveyEventSaga(action: { payload: any }): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
   
    const { id, assignTo, ...payload } = action?.payload;
   
    const apiResponse = yield call<any>(
      callAPI,
      { payload: payload },
      "put",
      `client/personal-events/${id}`,
    );
    
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setUpdateSurveyEventAction(true));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setUpdateSurveyEventAction(false));
  }
  yield put(setLoaderAction(false));
}

function* deleteSurveyEventSaga(action: any): any {
  yield put(setLoaderAction(true));
  try {
    
    const id = action.payload; // Directly access the payload
    const apiResponse = yield call<any>(
      callAPI,
      {},
      "delete",
      `client/personal-events/${id}`,
    );

    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setDeleteSurveyEventAction(true));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setDeleteSurveyEventAction(false));
  }
  yield put(setLoaderAction(false));
}

export function* watchSurveyDiary() {
  yield takeLatest<any>(
    getSurveyDiaryWithEventAction,
    getSurveyDiaryWithEventSaga,
  );
  yield takeLatest<any>(getSurveyDiaryAction, getSurveyDiarySaga);
  yield takeLatest<any>(getSurvoyerListAction, getSurvoyerListSaga);
  yield takeLatest<any>(getLeadToSurveyAction, getLeadToSurveySaga);
  yield takeLatest<any>(getSingleSurveyAction, getSingleSurveySaga);
  yield takeLatest<any>(addSurveyDiaryAction, addSurveyDiarySaga);
  yield takeLatest<any>(updateSurveyDiaryAction, updateSurveyDiarySaga);
  yield takeLatest<any>(addSurveyEventAction, addSurveyEventSaga);
  yield takeLatest<any>(getSingleSurveyEventAction, getSingleSurveyEventSaga);
  yield takeLatest<any>(updateSurveyEventAction, updateSurveyEventSaga);
  yield takeLatest<any>(deleteSurveyEventAction, deleteSurveyEventSaga);
  yield takeLatest<any>(updateNewSurveyAction, updateNewSurveySaga);
}
